import { MA_TRANSACTIONS_SUMMARY_QUERY } from '../operations';
import { useMaTransactionsContext } from '../../../MaTransactionsContext';
import { useQuery } from '@apollo/client';

export const useGetMaTransactionsSummary = () => {
  const { filterVariables } = useMaTransactionsContext();

  const { data, loading, error } = useQuery(MA_TRANSACTIONS_SUMMARY_QUERY, {
    variables: { filters: filterVariables },
  });

  return { data: data?.maTransactionsSummary || {}, loading, error };
};
